/* eslint-disable indent */
import { HttpTransportType } from "@microsoft/signalr";
import {
  EFeedEvents,
  FeedDeNovidadesSignal,
  IConnectOptions,
  IDeleteNotificationParams,
  IGetOpenNotificationParams,
  ISetReadNotificationParams,
  ISetViewNotificationParams
} from "./FeedDeNovidadesSignal";
import { DIMixins, DITypes } from "@/core/@types/types";
import { inject, injectable } from "inversify";
import { type IUserProfileStorageMixin } from "@/core/plugins/storage/UserProfileStorageMixin";
import { type IWebSocketClient } from "@/core/services/websocket/IWebSocketClient";

@injectable()
export default class FeedDeNovidadesSignalAdapter
  implements FeedDeNovidadesSignal
{
  @inject(DITypes.WEBSOCKET_CLIENT)
  private wsConnection!: IWebSocketClient;

  @inject(DIMixins.USER_PROFILE_STORAGE)
  profile!: IUserProfileStorageMixin;

  constructor() {}

  private async connect() {
    const profile = this.profile.handleGetUserProfile();

    const url = `eventHub?customerId=${profile?.GrupoId}`;

    if (import.meta.env.DEV) {
      return;
    }

    await this.wsConnection?.connect({
      url,
      transport:
        HttpTransportType.WebSockets |
        HttpTransportType.ServerSentEvents |
        HttpTransportType.LongPolling // Aceita todos os transportes
    });
  }

  async setup(options: IConnectOptions): Promise<void> {
    try {
      await this.connect();

      this.wsConnection?.on(
        EFeedEvents.ON_NOTIFICATION_RECEIVED,
        options.onNotificationReceived
      );
    } catch (_err) {
      //console.error("Feed SignalR Connection Error: ", err);
    }
  }

  async getOpenNotification(): Promise<void> {
    try {
      const profile = this.profile.handleGetUserProfile();

      await this.wsConnection?.send<IGetOpenNotificationParams>(
        EFeedEvents.GET_OPEN_NOTIFICATION,
        profile?.GrupoId
      );
    } catch (_err) {
      //console.error("Erro ao solicitar as notificações: ", err);
    }
  }

  async setReadNotification(
    params: Pick<ISetReadNotificationParams, "id" | "lido">
  ): Promise<void> {
    try {
      const profile = this.profile.handleGetUserProfile();

      await this.wsConnection?.send<ISetReadNotificationParams>(
        EFeedEvents.SET_READ_NOTIFICATION,
        params.id,
        params.lido,
        profile?.GrupoId
      );
    } catch (_err) {
      //console.error("Erro ao marcar a notificação como lida: ", err);
    }
  }

  async deleteNotification(params: IDeleteNotificationParams): Promise<void> {
    try {
      const profile = this.profile.handleGetUserProfile();

      await this.wsConnection?.send<ISetReadNotificationParams>(
        EFeedEvents.DELETE_NOTIFICATION,
        params.lidas,
        profile?.GrupoId
      );
    } catch (_err) {
      //console.error("Erro ao apagar as notificações: ", err);
    }
  }

  async setViewNotification(): Promise<void> {
    try {
      const profile = this.profile.handleGetUserProfile();

      await this.wsConnection?.send<ISetViewNotificationParams>(
        EFeedEvents.SET_VIEW_NOTIFICATION,
        profile?.GrupoId
      );
    } catch (_err) {
      //console.error("Erro ao marcar a notificação como lida: ", err);
    }
  }
}
